export const XDC_RPC_URL = process.env.REACT_APP_XDC_RPC_URL;

// AUTH ENDPOINTS
export const REFRESH_ACCESS_TOKEN = "/auth/refreshAccessToken";
export const GOOGLE_LOGIN = "/auth/googleLogin";
export const SELECT_USER_TYPE = "/auth/selectUserType";
export const USER_LOGIN = "/auth/login";
export const CLIENT_REGISTER = "/auth/clientRegister";
export const ADVOCATE_REGISTER = "/auth/advocateRegister";
export const USER_VERIFICATION = "/auth/verifyUserAccount";
export const FORGET_PASSWORD_EMAIL_SEND = "/auth/forget-password";
export const RESET_PASSWORD = "/auth/reset-password";
export const UPDATE_PASSWORD = "/auth/update-password";
export const LOGOUT_USER = "/auth/logout";

// ADVOCATE ENDPOINTS
export const GET_ADVOCATE_DETAILS = "/advocate/getAdvocateUser";
export const GET_ADVOCATE_LIST = "/advocate/getAdvocateList";
export const GET_ADVOCATE_TEMPLET_LIST = "/advocate/getAdvocateTempletList";
export const GET_ADVOCATE_TEMPLET_BY_ID = "/advocate/template";
export const GET_USER_CREATED_TEMPLATE = "/advocate/get-created-templets";
export const CREATE_ADVOCATE_TEMPLATE = "/advocate/template/create";
export const UPLOAD_ADVOCATE_TEMPLATE_CSV = "/advocate/template/csv/upload";

// CART ENDPOINTS
export const GET_USER_PURCHASED_DOC = "/cart/user-purchased-doc";
export const GET_PURCHASE_DOC = "/cart/purchasedoc";

// USER API ENDPOINTS
export const GET_USER_DETAILS = "/user/getUserDetails";
export const SEND_REQ_EMAIL = "user/sendRequestEmailToAdvocate";
export const UPDATE_USER_PROFILE = "/user/updateUserProfile";
export const GET_USER_DETAIL_BY_EMAIL = "/user/getdetailsbyemail";
export const GET_USER_OWN_TEMPLATE = "/user/template";
export const UPDATE_USER_OWN_TEMPLATE = "/user/update/template";

// SIGNATURE API ENDPOINTS
export const ADD_SIGNATURE = "/signature/addsignature";
export const GET_SIGNATURES = "/signature/getsignatures";
export const DELETE_SIGNATURE = "/signature/deletesignature";

// DOCUMENT-SIGN API ENDPOINTS
export const GET_PDFSIGN_DOCUMENT_BY_ID = "/docsign";
export const UPLOAD_SIGN_PDF = "/docsign/upload-doc";
export const UPDATE_SIGNDOC_WITH_SIGN = "/docsign/update/addsign";
export const COMPLETED_SIGN_PDF = "/docsign/completed-signdocs";
export const SHARED_SIGN_PDF = "/docsign/shared-signdocs";
export const ACTION_REQUIRED_SIGN_PDF = "/docsign/action-require-signdocs";

// DOC-SIGN PUBLIC ENDPOINTS
export const GET_PDFSIGN_DOCUMENT_BY_TOKEN = "/api/v1/docsign/token";
export const UPDATE_SIGNDOC_WITH_SIGN_BY_TOKEN =
  "/api/v1/docsign/update/addsign-by-token";

// IPFS ENDPOINTS
export const UPLOAD_CONTRACT_TO_IPFS = "/ipfs/upload-contract-ipfs";
export const FETCH_DOCUMENT_FROM_IPFS = "/ipfs/fetch-document";

// CREATE-DOCUMENT-AI ENDPOINTS
export const GET_DRAFT_LIST = "/create-doc/getdraftlist";
export const GET_SHARED_DRAFT_LIST = "/create-doc/shared-draftlist";
export const GET_UPLOADED_DRAFT_LIST = "/create-doc/uploaded-draftlist";
export const SAVE_DOC_DRAFT = "/create-doc/save-draf";
export const SHARE_DRAFT_WITH_EMAIL = "/create-doc/share-draft";
export const GET_DRAFT_BY_ID = "/create-doc/getdraft";
export const GET_SHARED_DRAFT_BY_ID = "/create-doc/get-shared-draft";
export const DELETE_DRAFT_BYID = "/create-doc/deletedraft";
export const DELETE_SHARED_DRAFT_BYID = "/create-doc/delete-shared-draft";
export const DELETE_IPFS_UPLOADED_DOC = "/create-doc/delete-ipfs-doc";
export const ADD_EDITED_DRAFT = "/create-doc/add-edtiteddraft";
export const ADD_EDITED_SHARED_DRAFT = "/create-doc/add-edited-shared-draft";

// DOCMODIFY ENDPOINTS
export const PARSE_DOC_TO_HTML = "/modify-doc/doc-tohtml";

// ADMIN ENDPOINTS
export const GET_COLLECTIONS_COUNT = "/admin/documentdetails";
export const PROMOTE_TO_ADMIN = "/admin/manage-user/promote-to-admin";
export const DEMOTE_ADMIN = "/admin/manage-user/demote-to-admin";
export const GET_ALL_USERS = "/admin/manage-user/allusers";
export const GET_ALL_LBT_ACCOUNTS = "/admin/lbt-accounts";
export const CREATE_LBT_ACCOUNTS = "/admin/lbt-accounts/create-with-balance";
export const ADMIN_GET_USERS_LIST = "/admin/manage-user/users-list";
export const ADMIN_ADD_USER = "/admin/manage-user/add-user";
export const ADMIN_BULK_IMPORT_USERS = "/admin/manage-user/bulk-import";
export const ADMIN_GET_API_USAGE_SUMMARY = "/admin/api-keys/usage-summary";
export const ADMIN_GET_USER_API_USAGE_DETAIL = "/admin/api-keys/user-usage";

// BLOG ENDPOINTS
export const GET_ALL_BLOGS = "/blog/allblogs";
export const GET_BLOG_BY_ID = "/blog/id";
export const ADD_NEW_BLOG = "/blog/addblog";
export const UPDATE_BLOG = "/blog/updateblog";
export const CHANGE_BLOG_STATUS = "/blog/changestatus";

// CONTACT US ENDPOINTS
export const GET_ALL_CONTACTUS_REQUESTS = "/contact-us/allrequestsdata";
export const ADD_CONTACTUS_REQUESTS = "/contact-us/addrequest";

// CRYPTO TRANSACTON ENDPOINTS
export const GET_XDC = "/crypto-tx/getxdc";
export const GET_LBT = "/crypto-tx/getlbt";
export const FETCH_XDC_BALANCE = "/crypto-tx/fetchXDCBalance";
export const FETCH_LBT_BALANCE = "/crypto-tx/fetchLBTBalance";

// AI ENDPOINTS
export const AI_GENERATE_DOCUMENT = "/ai/generate-document";
export const AI_GENERATE_DOCUMENT_STREAM = "/ai/generate-document/stream";
export const AI_CHAT = "/ai/chat";

// CMS ENDPOINTS ( PRICING AND FEATURES )
export const GET_ALL_PRICING_PLANS = "/cms/pricing-plans";
export const GET_ALL_ACTIVE_PRICING_PLANS = "/cms/pricing-plans/active";
export const ADD_NEW_PRICING_PLAN = "/cms/pricing-plans/add";
export const UPDATE_PRICING_PLAN = "/cms/pricing-plans/update";
export const DELETE_PRICING_PLAN = "/cms/pricing-plans/delete";
export const ACTIVATE_PLAN = "/cms/pricing-plans/activate";
export const DEACTIVATE_PLAN = "/cms/pricing-plans/deactivate";

export const GET_ALL_ACTIVE_FEATURES = "/cms/features/active";
export const GET_ALL_FEATURES = "/cms/features";
export const ADD_NEW_FEATURE = "/cms/features/add";
export const UPDATE_FEATURE = "/cms/features/update";
export const ACTIVATE_FEATURE = "/cms/features/activate";
export const DEACTIVATE_FEATURE = "/cms/features/deactivate";
export const DELETE_FEATURE = "/cms/features/delete";

export const GET_ALL_EVENTS = "/cms/events";
export const GET_ALL_ACTIVE_EVENTS = "/cms/events/active";
export const ADD_NEW_EVENT = "/cms/events/add";
export const UPDATE_EVENT = "/cms/events/update";
export const ACTIVATE_EVENT = "/cms/events/activate";
export const DEACTIVATE_EVENT = "/cms/events/deactivate";
export const DELETE_EVENT = "/cms/events/delete";

export const GET_ALL_PARTNERS = "/cms/partners";
export const GET_ALL_ACTIVE_PARTNERS = "/cms/partners/active";
export const ADD_NEW_PARTNER = "/cms/partners/add";
export const UPDATE_PARTNER = "/cms/partners/update";
export const ACTIVATE_PARTNER = "/cms/partners/activate";
export const DEACTIVATE_PARTNER = "/cms/partners/deactivate";
export const DELETE_PARTNER = "/cms/partners/delete";

export const PUBLIC_DOCUMENTS = "/cms/public-documents";

// LAWBLOCK PDF SIGNATURE ENDPOINTS
export const LAWBLOCKPDF_ADD_SIGNATURE = "/lawblockpdf/addsignature";
export const LAWBLOCKPDF_GET_SIGNATURES = "/lawblockpdf/getsignatures";
export const LAWBLOCKPDF_DELETE_SIGNATURE = "/lawblockpdf/deletesignature";

// NOTIFICATION ENDPOINTS
export const GET_ALL_NOTIFICATIONS = "/notifications/all";
export const MARK_NOTIFICATION_AS_READ = "/notifications/mark-as-read";
export const MARK_ALL_NOTIFICATIONS_AS_READ = "/notifications/mark-all-read";

export const ADMIN_CONTRACT_SETTINGS = "/admin/app-settings/contract-settings";
export const SITE_CONTRACT_SETTINGS = "/site/contract-settings";

// EMAIL TEMPLATE ENDPOINTS
export const ADMIN_GET_EMAIL_TEMPLATES = "/admin/email-templates";
export const ADMIN_CREATE_EMAIL_TEMPLATE = "/admin/email-templates";
export const ADMIN_UPDATE_EMAIL_TEMPLATE = "/admin/email-templates"; // + /:id
export const ADMIN_DELETE_EMAIL_TEMPLATE = "/admin/email-templates"; // + /:id

// CLOUDINARY ENDPOINTS
export const GET_SIGNATURE = "/cloudinary/signature";

